module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "returnMaterManage"
    }
  }, [_c('el-col', {
    staticClass: "searthPart"
  }, [_c('el-form', {
    ref: "searchForm",
    attrs: {
      "inline": true,
      "model": _vm.searchForm,
      "label-position": _vm.labelPosition
    }
  }, [_c('el-form-item', {
    staticClass: "hewidth"
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "placeholder": "请输入退料编码",
      "maxlength": "50"
    },
    model: {
      value: (_vm.searchForm.returnNumber),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "returnNumber", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "searchForm.returnNumber"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "hewidth"
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "placeholder": "序列号",
      "maxlength": "50"
    },
    model: {
      value: (_vm.searchForm.inventoryCode),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "inventoryCode", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "searchForm.inventoryCode"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "hewidth"
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "placeholder": "对应服务单号",
      "maxlength": "50"
    },
    model: {
      value: (_vm.searchForm.orderNo),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "orderNo", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "searchForm.orderNo"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "hewidth"
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "filterable": "",
      "filter-method": _vm.PinyinMatch,
      "placeholder": "退料人"
    },
    on: {
      "change": _vm.changeBelonger
    },
    model: {
      value: (_vm.searchForm.belonger),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "belonger", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "searchForm.belonger"
    }
  }, _vm._l((_vm.returnPersonList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "hewidth"
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "残值类型",
      "clearable": ""
    },
    model: {
      value: (_vm.searchForm.residualType),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "residualType", $$v)
      },
      expression: "searchForm.residualType"
    }
  }, _vm._l((_vm.residualList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.paraName,
        "value": item.paraValue
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "hewidth"
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "退料类型",
      "clearable": ""
    },
    model: {
      value: (_vm.searchForm.returnType),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "returnType", $$v)
      },
      expression: "searchForm.returnType"
    }
  }, _vm._l((_vm.returnList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.paraName,
        "value": item.paraValue
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }, [_c('el-form-item', {
    staticClass: "hewidth"
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "状态",
      "clearable": ""
    },
    model: {
      value: (_vm.searchForm.status),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "status", $$v)
      },
      expression: "searchForm.status"
    }
  }, _vm._l((_vm.statusList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.paraName,
        "value": item.paraValue
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "hewidth"
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "是否自留",
      "clearable": ""
    },
    model: {
      value: (_vm.searchForm.isRetenRetain),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "isRetenRetain", $$v)
      },
      expression: "searchForm.isRetenRetain"
    }
  }, _vm._l((_vm.isRetenRetainList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.paraName,
        "value": item.paraValue
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "34%"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "range-separator": "-",
      "default-time": ['00:00:00', '23:59:59'],
      "start-placeholder": "退料开始",
      "end-placeholder": "退料开始"
    },
    model: {
      value: (_vm.valueTime3),
      callback: function($$v) {
        _vm.valueTime3 = $$v
      },
      expression: "valueTime3"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "30%"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "type": "primary",
      "size": "medium"
    },
    on: {
      "click": function($event) {
        return _vm.onSubmit('searchForm')
      }
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "width": "60px",
      "color": "#169BD5"
    },
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        return _vm.clearForm()
      }
    }
  }, [_vm._v("重置")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "success",
      "size": "medium"
    },
    on: {
      "click": function($event) {
        return _vm.downLoad.exportExcel('tableId')
      }
    }
  }, [_vm._v("导出")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-card', {
    staticClass: "box-card",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "tableId",
      "data": _vm.returnData,
      "border": "",
      "header-cell-style": {
        'text-align': 'center'
      }
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "shopName",
      "width": "110",
      "label": "网点名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "engineerName",
      "label": "退料人"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "createUser",
      "label": "收料人"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "modelName",
      "width": "150",
      "label": "型号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "materialCode",
      "width": "100",
      "label": "物料编码"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "materialName",
      "width": "250",
      "label": "物料名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "inventoryCode",
      "width": "100",
      "label": "序列号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "code",
      "label": "数量"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v("1")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "status",
      "label": "状态"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status == 'YQR') ? _c('span', [_vm._v("已确认")]) : _vm._e(), _vm._v(" "), (scope.row.status == 'save') ? _c('span', [_vm._v("暂存")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "orderNo",
      "width": "180",
      "label": "对应服务单号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "createTime",
      "width": "155",
      "label": "退料日期"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "residualType",
      "width": "100",
      "label": "残值类型"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                          " + _vm._s(_vm._f("sysCodeFileter")(scope.row.residualType, 'residual_type')) + "\n                      ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "residualValue",
      "label": "残值价格"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "width": "100",
      "prop": "isRetenRetain",
      "label": "是否保留"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                          " + _vm._s(_vm._f("sysCodeFileter")(scope.row.isRetenRetain, 'is_reten_retain')) + "\n                      ")]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "current-page": _vm.pages.page,
      "page-sizes": [10, 20, 50, 100, 1000],
      "page-size": _vm.pages.pageSize,
      "layout": "total, sizes, prev, pager, next,jumper",
      "total": _vm.pages.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/template-compiler?{"id":"data-v-a6e22b94","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!/opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/storehouseManage/returnMaterManage.vue
// module id = 1739
// module chunks = 0